import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	for (const element of document.querySelectorAll(".excluded-by-region")) {
		element.remove();
	}
	$('.product-carousel .products').slick({
		arrows: false,
		autoplay: true,
		autoplaySpeed: 10000,
		centerMode: false,
		centerPadding: 0,
		cssEase: 'linear',
		dots: true,
		draggable: true,
		fade: false,
		infinite: true,
		pauseOnHover: true,
		slidesToShow: 1,
		variableWidth: false,
		slidesToScroll: 1,
		speed: 250,
		responsive: [

		]
	});
})
